import React, { useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import styles from './error.module.css';
import useTranslation from '../../hooks/use-translation';
import caveman from '../../images/caveman.svg';
import { useHistory } from 'react-router-dom';

const styleSet = {
  buttonDisabled: {
    textTransform: 'none',
    height: '2em',
    width: '10em',
    border: 'none',
    backgroundColor: '#93BED8',
    color: '#ffffff',
    fontSize: '1em',
    fontFamily: 'jioType-Medium',
    outline: 'none',
    marginTop: '1em'

  },
  actionButton: {
    fontFamily: 'JioType-Medium',
    color: '#FFFFFF',
    fontSize: '16px',
    width: '10em',
    alignSelf: 'center',
    backgroundColor: '#214796',
    outline: 'none',
    height: '2em',
    border: 'none',
    marginTop: '1em'

  }
};

export default props => {
  const { t } = useTranslation();
  const [retryLoading, setRetryLoading] = useState(false);
  const {
    handleRetry = {},
    retryText = t('RETRY_TEXT'),
    buttonText = t('RETRY')
  } = props;
  const history = useHistory();
  const handleClick = async () => {
    // setRetryLoading(true);
    // await handleRetry();
    // setRetryLoading(false);
    history.push('/');
  };
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div>
          <img src={caveman} className={styles.caveman} alt="" />
        </div>
        <div className={styles.text}>
          {retryText}
        </div>
        <button style={retryLoading ? styleSet.buttonDisabled : styleSet.actionButton} onClick={handleClick}>

          <span>
            {' '}
            {retryLoading ? (
              <span>
                <CircularProgress size={20} />
                {' '}
              </span>
            ) : buttonText}
          </span>
        </button>
      </div>
    </div>
  );
};
